/**
 * Application namespace, global application object
 */

define(function(require, exports, module) {
    const { dispatcher } = require('bundle');
    const core = require('core');
    const config = require('config');

    dispatcher.listen('menu:items', (menuItems) => {
        config.load({ menuItems: menuItems });
        core.trigger('page:initialResourcesLoaded:menuItems');
    });

    module.exports = core;
});
